import React, { useState, useRef } from 'react';
import { useDispatch } from 'react-redux';

import * as constants from '../../helpers/constants';

import { searchAddressSelected } from '../../actions/mainview/mainview';

const Geocoder = props => {

  const dispatch = useDispatch(),
        [addresses, setAddresses] = useState([]),
        [noResultsFound, setNoResultsFound] = useState(false),
        [isEmpty, setIsEmpty] = useState(true),
        inputRef = useRef(null),
        apiToken = process.env.REACT_APP_Mapbox_API_Key;

  const _resetSearch = clearInput => {

    if (inputRef.current.value === '') return false;

    setAddresses([]);
    setIsEmpty(true);

    if ((props.isInline && clearInput) || clearInput) inputRef.current.value = '';
  }

  const _getSearchQuery = e => {

    const query = e.target.value;

    if (query === '') return setIsEmpty('true');

    const reqUrl = `${ constants.MAPBOX_GEOCODE_URL }/${ encodeURIComponent(query) }.json?access_token=${ apiToken }&country=${ props.countryLimit }${ props.isInline ? '' : `&proximity=${ props.mapCenter?.lng },${ props.mapCenter?.lat }` }`;
    
    fetch(reqUrl)
    .then(res => res.json())
    .then(json => {
      if (json.message || json.features.length < 1) {
        setNoResultsFound(true);
        setAddresses([]);
        setIsEmpty(false);

        return false;
      }

      setNoResultsFound(false);
      setAddresses(json.features);
      setIsEmpty(false);
    });

  }

  const _addressSelected = address => {
    
    if (props.isInline) {
      inputRef.current.value = address.place_name;
      _resetSearch();

      props.onInlineChange(address);
    }
    else {
      dispatch(searchAddressSelected(address));
      _resetSearch(true);
    }

  }

  return (
    <div className={ `geocoder ${ props.isInline ? 'geocoder--inline' : '' }` }>
      {
        !isEmpty &&
        <span className="geocoder__reset" onClick={ () => _resetSearch(true) } title="Clear search">&times;</span>
      }
      {
        !props.isInline &&
        <i className="geocoder__icon fa fa-map-marker-alt"></i>
      }
      {/* <input className={`geocoder__input ${ props.className }`} name={ props.name } onChange={ props.isInline ? props.onInlineChange : null } onInput={ e => _getSearchQuery(e) } ref={ inputRef } placeholder="Search for an address" title="Search for an address" defaultValue={ props.defaultValue !== undefined ? props.defaultValue : '' } /> */}
      <input className={`geocoder__input ${ props.className }`} name={ props.name } onInput={ e => _getSearchQuery(e) } ref={ inputRef } placeholder="Search for an address" title="Search for an address" />

      <ul className="geocoder__results">
        {
          !noResultsFound &&
          !isEmpty &&
          addresses.map((address, idx) => {
            return (
              <li className="geocoder__result" key={ idx } onClick={ () => _addressSelected(address) }>
                <span className="geocoder__result-text">{ address.text }</span>
                <span className="geocoder__result-address">{ address.place_name }</span>
              </li>
            )
          })
        }

        {
          noResultsFound &&
          !isEmpty &&
          <li className="geocoder__result geocoder__result--no-result">No Results Found.</li>
        }
      </ul>

    </div>
  );
  
}

export default Geocoder;